import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { components, contentfulModels } from '@glowforge/ui-common';
import features from 'app/common/containers/features';
import { machinePropType } from 'app/selectors/machines';
import strings from 'app/strings';
import { ACCOUNT_ACCESS } from 'app/app-constants';

import './printers.less';

const { MachineBadge, Button, SVG } = components;

const { pageStringsPropType } = contentfulModels;
const { USER_MACHINE_ROLES } = strings;

function ownershipDashboardLink() {
  return `${global.sharedEnv.GFCORE_SERVER}/ownership-dashboard`;
}

const Printers = (props) => {
  const {
    features,
    isLoading,
    isRestricted,
    machines,
    pageStrings 
  } = props;

  const addAPrinter = () => {
    if (machines.length > 0) {
      window.open('/setup/add_glowforge', '_blank');
    } else {
      window.open('/setup/first_glowforge', '_blank');
    }
  };
  const releaseAPrinter = () => {
    window.open(ownershipDashboardLink(), '_blank');
  };

  let ownsAPrinter = false;

  // TODO: probably should add usersString, owned by text, table headers, etc. to contentful

  const printers = _.map(machines, (printer) => {
    let usersString = '1 user has access';
    if (printer.userCount > 1) usersString = `${printer.userCount} users have access`;
    if (printer.userCount === 0) usersString = null; // User doesn't have management access

    let lastPrintString = 'Never';
    if (printer.lastPrintAt) lastPrintString = moment(printer.lastPrintAt).format('l');

    let roleString = pageStrings['settings-users-role-label-standard-user'] || USER_MACHINE_ROLES.standard_user;
    // TODO: When modifying this to make only the "guest" role be subscriptions,
    // then the 'legacy' else below goes away.
    if (printer.isAdmin && !isRestricted) {
      if (features.USER_ROLE_MANAGEMENT) {
        roleString = pageStrings['settings-users-role-label-manager'] || USER_MACHINE_ROLES.manager;
      } else { // legacy, non-user-role case
        roleString = ACCOUNT_ACCESS.FULL_ACCESS;
      }
    } else {
      roleString = ACCOUNT_ACCESS.RESTRICTED;
    }
    if (printer.isOwner) {
      roleString = pageStrings['settings-users-role-label-owner'] || 'Owner';
      ownsAPrinter = true;
    }

    return (
      <tr key={printer.machineName}>
        <td className='name'>{printer.machineName}<MachineBadge model={printer.model} /></td>
        <td>{roleString}</td>
        <td>{lastPrintString}</td>
        <td>
          <div>{usersString}</div>
          <div>(owned by {printer.ownerName})</div>
        </td>
      </tr>
    );
  });

  let loading;
  if (isLoading) {
    loading = <div className='loadingIndicator'><SVG id='spinner' /></div>;
  }

  const ownershipDashboardButton = (
    ownsAPrinter ?
      <Button className='secondaryButton secondary' onClick={releaseAPrinter}>Release a Printer</Button>
      :
      null
  );

  const addPrinterButton = (
    isRestricted ? null : <Button onClick={addAPrinter}>Add a Printer</Button>
  );

  return (
    <div className='Printers'>
      <h1 className='h2'>Glowforge Printers
        <span className='buttonsRight'>
          {ownershipDashboardButton}
          {addPrinterButton}
        </span>
      </h1>
      <div className='tableWrapper'>
        <table className={`styledTable striped ${isLoading ? 'loading' : ''}`}>
          <thead>
            <tr className='header label'>
              <th>Glowforge Name</th>
              <th>Your Role</th>
              <th>Last Print</th>
              <th>Users</th>
            </tr>
          </thead>
          <tbody>
            {printers}
          </tbody>
        </table>
        {loading}
      </div>
    </div>
  );
};

Printers.propTypes = {
  machines: PropTypes.arrayOf(PropTypes.shape(machinePropType)),
  isLoading: PropTypes.bool,
  isRestricted: PropTypes.bool,
  features: PropTypes.object, // eslint-disable-line
  pageStrings: pageStringsPropType.isRequired,
};

Printers.defaultProps = {
  machines: [],
  isLoading: false,
  isRestricted: false,
};

export default features(Printers);



// WEBPACK FOOTER //
// ./app/components/settings/printers.jsx